export {default} from './Main';



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Main/index.ts